<script>
import { SeasonPageElementMixin } from "%/dynamic-component-editor/standard-pages/season-page/season-page-element-mixin";
import TextElement
  from "%/dynamic-component-editor/standard-elements/text-element/TextElement.vue";
import BrandedTextStyleOptions from "%/dynamic-component-editor/bundles/branded-text-style-options";

export default {
  name: "SeasonNumEpisodes",
  elementPanelSettings: {
    displayName: "Number of Episodes",
    displayIcon: "material-symbols:format-list-numbered",
    elementGroup: "season",
    elementType: "element",
  },
  extends: TextElement,
  mixins: [SeasonPageElementMixin],
  optionBundles: [
    new BrandedTextStyleOptions({}, {
      "text-option": true,
    }),
  ],
  computed: {
    isEditable() {
      return false;
    },
    value() {
      return this.entity.numEpisodes;
    },
  },
};
</script>
